import { jsx as _jsx } from "react/jsx-runtime";
var Heart2 = function Heart2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.18 * size,
    height: size,
    viewBox: "0 0 38 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M19.18 32L5.515 21.097c-.82-.457-1.698-1.155-2.463-1.98l-1.476-1.984A11.456 11.456 0 0 1 0 11.325C0 5.08 4.973 0 11.085 0c3.021 0 5.836 1.226 7.914 3.408C21.078 1.228 23.89 0 26.913 0 33.026 0 38 5.08 38 11.325c0 2.055-.549 4.05-1.571 5.794l-1.452 1.963a11.07 11.07 0 0 1-2.512 2.036L19.18 32zM4.838 17.566a8.796 8.796 0 0 0 1.969 1.548l12.354 9.84 11.983-9.802c.86-.525 1.526-1.062 2.11-1.69l.099-.112a9.013 9.013 0 0 0 2.305-6.023c0-4.928-3.924-8.935-8.748-8.935-2.761 0-5.306 1.302-6.98 3.571l-.935 1.265-.935-1.266c-1.672-2.268-4.217-3.57-6.979-3.57-4.823 0-8.745 4.007-8.745 8.935 0 2.247.83 4.398 2.334 6.06l.167.18z"
    })
  });
};
export default Heart2;